export enum CartContext {
  ADD_CART = 'add_cart',
  ADD_HEADER = 'add_header',
  REMOVE_CART = 'remove_cart',
  REMOVE_HEADER = 'remove_header',
  UPDATE_CART = 'update_cart',
  UPDATE_HEADER = 'update_header',
  ADD_WISHLIST_CART = 'add_wishlist_cart',
}
